<template>
  <div>
    <breadcrumbs home="Spirit"/>

    <v-card flat>
      <v-tabs v-model="tab" class="full-height-tab" show-arrows>
        <v-tab>Info</v-tab>
        <v-tab>Purchasing</v-tab>
        <v-tab>Selling</v-tab>

        <v-tab-item>
          <spirits-edit-info :spirit="spirit" :accounts="inventoryAccounts" :values="values" ref="info"/>
        </v-tab-item>
        <v-tab-item eager>
          <spirits-edit-buying :spirit="spirit" :taxes="taxes.filter(tax => tax.purchaseRate !== null)" ref="buying"/>
        </v-tab-item>
        <v-tab-item eager>
          <spirits-edit-selling :spirit="spirit" :taxes="taxes.filter(tax => tax.salesRate !== null)" :values="values" :incomeAccounts="incomeAccounts" :cogAccounts="cogAccounts" ref="selling"/>
        </v-tab-item>
      </v-tabs>

      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import SpiritsEditInfo from '@/views/alcohol/spirits/SpiritsEditInfo'
import SpiritsEditBuying from '@/views/alcohol/spirits/SpiritsEditBuying'
import SpiritsEditSelling from '@/views/alcohol/spirits/SpiritsEditSelling'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'SpiritsEdit',
  mixins: [confirmLeave],
  components: {SpiritsEditInfo,SpiritsEditBuying,SpiritsEditSelling},
  props: {
    spiritId: {type:String, required:false}
  },
   data () {
      return {
        accounts: [],
        taxes: [],
        spirit: {vendors:[],customers:[]},
        dirty: false,
        saving: false,
        loading: false,
        tab: 0
      }
    },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    },
    inventoryAccounts() {
      return this.accounts.filter(account => account.type === 'OtherCurrentAsset');
    },
    incomeAccounts() {
      return this.accounts.filter(account => account.type === 'Income');
    },
    cogAccounts() {
      return this.accounts.filter(account => account.type === 'CostOfGoodsSold');
    },
    values() {
      return this.$store.getters.company.permissions.includes('values') && this.$store.getters.company.settings.useAccounts;
    }
  },
  watch: {
    spirit: {
      handler() {this.dirty=true},
      immediate: true,
      deep: true
    }
  },
  async created() {
    this.loading = true;
    this.$lazyListLoad(this.taxes, 'taxes2', 'id,name,salesRate,purchaseRate', 100);
    const results = await this.$apiCall(`query SpiritsEdit($id:ID!,$currency:String!,$edit:Boolean!) {
                                              spirit(id:$id) @include(if:$edit) {
                                                id,name,sku,active,
                                                reorderPoint,
                                                inventoryAccountRef,incomeAccountRef,cogAccountRef,
                                                reorderQuantity,reorderDays,reorderBusinessDays,
                                                commissionExempt,
                                                buyingDescription,preferredVendor{id},
                                                sellingDescription,defaultPrice,defaultTax{id}
                                                vendors{vendorId,tax{id},sku,cost},
                                                customers{category,customerId,tax{id},sku,price},
                                              }
                                              accounts(currency:$currency) {
                                                ref,name,type
                                              }
                                              companyAccounts @skip(if:$edit) {spiritInventory,spiritCOG,spiritIncome}
                                            }`,
                                        {id:this.spiritId||'',currency:this.$store.getters.company.settings.homeCurrency,edit:this.spiritId!==undefined});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }

    this.accounts = results.data.accounts;

    if (this.spiritId) {
      this.spirit = {...results.data.spirit,
                     preferredVendorId:results.data.spirit.preferredVendor?.id,preferredVendor:undefined,
                     defaultTaxId:results.data.spirit.defaultTax?.id,defaultTax:undefined,commissionExempt:false,
                     vendors:results.data.spirit.vendors.map(v => ({...v,taxId:v.tax.id,tax:undefined})),
                     customers:results.data.spirit.customers.map(c => ({...c,taxId:c.tax.id,tax:undefined}))
                    };

      if (this.$route.query.tab)
        this.tab = parseInt(this.$route.query.tab);
    }
    else {
      this.spirit = {name:'',sku:'',active:true,
                   reorderPoint:-1,reorderQuantity:0,reorderDays:0,reorderBusinessDays:false,
                   inventoryAccountRef:results.data.companyAccounts.spiritInventory,
                   incomeAccountRef:results.data.companyAccounts.spiritIncome,
                   cogAccountRef:results.data.companyAccounts.spiritCOG,
                   buyingDescription:'',vendors:[],preferredVendorId:null,
                   sellingDescription:'',defaultPrice:0,defaultTaxId:null,customers:[]};
    }
    this.$nextTick(() => this.dirty = false);
    this.loading = false;
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      let valid = true;
      if (!this.$refs.info.valid) {
        this.tab = 0;
        valid = false;
      }
      else if (this.$refs.buying && !this.$refs.buying.valid) {
        this.tab = 1;
        valid = false;
      }
      else if (this.$refs.selling && !this.$refs.selling.valid) {
        this.tab = 2;
        valid = false;
      }

      if (!valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      const input = Object.assign({}, this.spirit);
      const results = await this.$apiCall(`mutation SpiritsEdit($input: SpiritInput!) {
                                             spiritCreate(input:$input) {id}
                                           }`,
                                          {input})
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.spirit.id?'Updated':'Created'} spirit ${this.spirit.name}`});
      }
    }
  }
}
</script>